import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["monthlyPrice", "annualPrice", "monthlyTab", "annualTab"];

  connect() {
    this.showMonthly();
  }

  showMonthly() {
    this.monthlyPriceTargets.forEach((el) => el.classList.remove("hidden"));
    this.annualPriceTargets.forEach((el) => el.classList.add("hidden"));
    this._activateTab(this.monthlyTabTarget, this.annualTabTarget);
  }

  showAnnual() {
    this.annualPriceTargets.forEach((el) => el.classList.remove("hidden"));
    this.monthlyPriceTargets.forEach((el) => el.classList.add("hidden"));
    this._activateTab(this.annualTabTarget, this.monthlyTabTarget);
  }

  // Private

  _activateTab(active, inactive) {
    active.classList.add("bg-primary", "text-primary-content");
    active.classList.remove("text-base-content/50");
    inactive.classList.remove("bg-primary", "text-primary-content");
    inactive.classList.add("text-base-content/50");
  }
}
